import { forwardRef } from "react";
import type { LucideIcon, LucideProps } from "lucide-react";

/**
 * The EyeCaptain eye as a drop-in for a lucide icon.
 *
 * It stands where the app used lucide's Sparkles: the AI insight headers,
 * upgrade prompts, the "what we found" moments. Sparkles is the stock symbol
 * for "AI did this" and reads as generated UI; the eye is our own mark and
 * says the same thing in the product's voice.
 *
 * Same geometry as Gaze in EcIcons.tsx. It takes LucideProps and forwards the
 * ref, so it can sit in any `icon: LucideIcon` slot and take the same
 * className, size and strokeWidth a lucide icon would.
 */
export const EcMark = forwardRef<SVGSVGElement, LucideProps>(function EcMark(props, ref) {
  const { size = 24, strokeWidth = 2, color = "currentColor", absoluteStrokeWidth, ...rest } = props;
  const sw = absoluteStrokeWidth ? (Number(strokeWidth) * 24) / Number(size) : strokeWidth;
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={sw}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      {...rest}
    >
      <path d="M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12Z" />
      <circle cx="11.4" cy="12" r="2.6" />
    </svg>
  );
}) as LucideIcon;
